<template>
  <div class="topDiv">
    <el-row style="text-align: left; padding-left: 28px; background: white">{{
      item.titile
    }}</el-row>
    <el-row class="item">
      <!-- <el-col> -->
      <div class="imgPosi">
        <img class="imgWZ" src="../assets/pcImage/temp/2.jpg" alt />
        <!-- <img class="imgStatus" src="../assets/pcImage/customerService.png" alt /> -->
      </div>
      <!-- </el-col> -->
      <!-- <el-col style="height:170px;padding-top:20px"> -->
      <ul>
        <li class="title">{{ item.msgAbstract }}</li>
        <li class="tContent" style="margin-top: 10px">
          <span class="tLbl">{{ item.createTime }}</span>
        </li>
        <li class="tContent">
          <span
            class="tLbl"
            style="
              width: 60px;
              height: 20px;
              border-radius: 2px;
              border: 1px solid #f82b18;
              font-size: 12px;
              color: #f82b18;
              line-height: 18px;
              padding: 0 5px;
            "
            >系统通知</span
          >
        </li>
      </ul>
      <!-- </el-col> -->
    </el-row>
    <div style="width: 100%; height: 1px; border-top: 1px solid #f2f2f2"></div>
  </div>
</template>
<script>
export default {
  name: "NewsComp",
  props: ["item"],
  data() {
    return {
      msg: "",
    };
  },
  created() {
    this.msg = this.item.msgContent;
    this.msg = this.msg.replace(/(\n)/g, "");
    this.msg = this.msg.replace(/(\t)/g, "");
    this.msg = this.msg.replace(/(\r)/g, "");
    this.msg = this.msg.replace(/<\/?[^>]*>/g, "");
    this.msg = this.msg.replace(/\s*/g, "");
  },
};
</script>
<style lang="stylus" scoped>
.topDiv {
  font-size: 18px;
  font-family: SourceHanSansCN-Bold, SourceHanSansCN;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  // line-height: 27px;
  margin-top: 20px;
  width: 100%;
  background: white;
  cursor: pointer;

  .item {
    background-color: white;
    display: flex;
    justify-content: flex-start;
    padding: 20px 0px 15px 27px;

    .imgStatus {
      width: 54px;
      height: 20px;
      position: absolute;
      left: 28px;
      top: 30px;
    }

    .imgWZ {
      width: 224px;
      height: 138px;
      // position: absolute;
      left: 28px;
      top: 12px;
    }

    .btn {
      background: #f82b18;
      border-radius: 6px;
      color: white;
      margin-top: 27px;
    }

    .hmc {
      display: block;
      font-size: 14px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 21px;
      margin-top: 8px;
    }
  }

  ul, li {
    list-style: none;
    text-align: left;
    // margin-bottom: 20px;
    margin: 5px 0px 20px 15px;
    padding-top: 0px;
  }

  .tLbl {
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 21px;
    color: #bcbcbc;
  }

  .tContent {
    font-size: 14px;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 21px;

    span {
      margin-right: 8px;
    }
  }

  .title {
    font-size: 14px;
    font-weight: bold;
    color: #bcbcbc;
    line-height: 27px;
  }
}
</style>